<template>
  <div class="phone-address posRe">
    <template v-if="cityData&&cityData.length">
      <div class="swiper-container container-address">
        <div class="swiper-wrapper">
          <div class="swiper-slide"
               :class="[cityIndex==-1?'active':'']"
               @click="cityTo(0,-1,-1,true)">
            <p>全部</p>
          </div>
          <template v-for="(one,oneIndex) in cityData">
            <div class="swiper-slide"
                 :class="[cityIndex==oneIndex?'active':'']"
                 :key="'one'+oneIndex"
                 @click="cityTo(one.cityId,oneIndex,-1,true)"
            >
              <p>{{one.name}}</p>
            </div>
          </template>
        </div>
      </div>
    </template>
    <template v-if="countyData&&countyData.length">
      <div class="county-list-all" :class="[countyMoreBool?'county-list-all-active':'']">
        <div class="county-list">
          <div :class="[countyIndex==-1?'active':'']"
               @click="cityTo(twoAllCityId,cityIndex,-1)">全部</div>
          <template v-for="(two,twoIndex) in countyData">
            <div :class="[countyIndex==twoIndex?'active':'']"
                 :key="'two'+twoIndex"
                 @click="cityTo(two.cityId,cityIndex,twoIndex)"
            >
              <p>{{two.name}}</p>
            </div>
          </template>
        </div>
        <i class="icon-img icon-down" @click="seeMore" v-if="countyData.length>5"></i>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ['addressType', 'parameter'],
  name: 'phoneAddress',
  data () {
    return {
      addressData: [],
      cityData: [],
      countyData: [],
      cityId: 0,
      containerAddress: '',
      twoAllCityId: 0,
      countyMoreBool: false,
      cityIndex:0,
      countyIndex:0,
    }
  },
  components: {
  },
  created () {
    let that = this;
    let currentParams = JSON.parse(this.publicJs.decode(that.$route.query));
    that.cityId = currentParams.cityId || 0;
    that.httpData()
  },
  mounted () {
  },
  methods: {
    httpData: function () {
      let that = this;
      that.publicJs.addressGetData(function (res) {
        if (res.code === 1) {
          that.addressData = res.data;
          that.cityData = res.data;
          let city=that.publicJs.onlyCityData(res.data,that.cityId);
          that.publicJs.changeDocumentTitle(city.name,that.cityId);
          that.cityIndex=city.i?city.i:city.index;
          that.countyIndex=city.i?city.index:-1;
          that.twoAllCityId = that.cityId||-1;
          that.$emit('cityId', city.cityId);
          that.swiperFun();
          that.countyDataFun()
        }
      })
    },
    swiperFun: function () { // 职业轮播
      let that = this
      that.$nextTick(function () {
        // eslint-disable-next-line
        that.containerAddress = new Swiper('.container-address', {
          slidesPerView: 'auto',
          spaceBetween: 32,
          observer: true,
          observeSlideChildren: true,
          observeParents: true,
          watchOverflow: true,
          breakpoints: {
            1380: {
              // spaceBetween: 60
            }
          }
        })
        that.containerAddress.slideTo(that.cityIndex);
      })
    },
    cityTo: function (id, cityIndex, countyIndex, bool) {
      let that = this;
      if (bool) {
        that.countyMoreBool = false
      }
      that.cityId = id;
      that.cityIndex = cityIndex;
      that.countyIndex = countyIndex;
      that.twoAllCityId = cityIndex >= 0 ? that.cityData[cityIndex].cityId : 0;
      that.containerAddress.slideTo(cityIndex);
      that.$emit('cityId', id)
    },
    countyDataFun: function () {
      let that = this;
      if (that.cityIndex >= 0) {
        let countyChild = that.cityData[that.cityIndex].child;
        that.countyData = countyChild && countyChild.length ? countyChild : []
      } else {
        that.countyData = []
      }
    },
    seeMore: function () {
      this.countyMoreBool = !this.countyMoreBool
    }
  },
  computed: {},
  watch: {
    cityIndex: {
      handler: function (a, b) {
        if (a !== b && this.cityData && this.cityData.length) {
          this.countyDataFun()
        }
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .phone-address{
    background: #FFFFFF;
    border-radius: 8px;
  }
  .swiper-container{
    padding: 20px 10px 14.5px;
  }
  .container-address .swiper-slide{
    width: auto;
    font-size: 14px;
    color: #333333;
    cursor: pointer;
  }
  .container-address .swiper-slide.active{
    font-size: 17px;
    position: relative;
  }
  .container-address .swiper-slide.active::after{
    content: '';
    position: absolute;
    width: 20px;
    height:2px;
    background-color:#248DDF;
    border-radius: 2px;
    left: 50%;
    bottom: -5px;
    margin-left: -10px;
  }
  .county-list-all{
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-right: 35px;
    padding-left: 10px;
    padding-bottom: 20px;
    position: relative;
    -webkit-animation: slideInUp 0.5s;
    -o-animation: slideInUp 0.5s;
    animation: slideInUp 0.5s;
  }
  .county-list{
    display: flex;
    flex-wrap: wrap;
    height: 26px;
    overflow-y: hidden;
    -webkit-transition: height 0.5s;
    -moz-transition: height 0.5s;
    -ms-transition: height 0.5s;
    -o-transition: height 0.5s;
    transition: height 0.5s;
  }
  .county-list-all-active .county-list{
    height: auto;
    -webkit-transition: height 0.5s;
    -moz-transition: height 0.5s;
    -ms-transition: height 0.5s;
    -o-transition: height 0.5s;
    transition: height 0.5s;
  }
  .county-list>div{
    padding: 3px 8px;
    font-size: 14px;
    cursor: pointer;
    color: #666;
    border-radius: 4px;
    margin-right: 4px;
    margin-bottom: 2px;
  }
  .county-list>div.active{
    background-color: #248DDF;
    color: white;
  }
  .icon-down{
    position: absolute;
    top:8px;
    right: 10px;
    -webkit-transition: transform 0.5s;
    -moz-transition: transform 0.5s;
    -ms-transition: transform 0.5s;
    -o-transition: transform 0.5s;
    transition: transform 0.5s;
  }
  .county-list-all-active .icon-down{
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
    -webkit-transition: transform 0.5s;
    -moz-transition: transform 0.5s;
    -ms-transition: transform 0.5s;
    -o-transition: transform 0.5s;
    transition: transform 0.5s;
  }
</style>



// WEBPACK FOOTER //
// src/components/Phone/address.vue